import React from "react";
import { NavLink } from "react-router-dom";
import { config, requestLogout } from "../../constants/constant";

const Footer = (props) => {

  return (
    <React.Fragment>
      <section className="footer-section">
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 text-center"
              style={{ fontSize: "13px", paddingBottom: "13px" }}
            >
              <p>
                Copyright © Dotgo 2023-2024. All rights reserved &nbsp; &nbsp;
                | &nbsp; &nbsp;{" "}
                <a href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer-pp`} className="" target="_blank">
                  Privacy Policy
                </a>{" "}
                &nbsp; &nbsp; | &nbsp; &nbsp;{" "}
                <a
                  href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer-tos`}
                  className=""
                  target="_blank"
                >
                  Terms of Service
                </a>
                &nbsp; &nbsp; | &nbsp; &nbsp;{" "}
                <a
                  href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/rbm-terms`}
                  className=""
                  target="_blank"
                >
                  RBM Terms
                </a>
                &nbsp; &nbsp; | &nbsp; &nbsp;{" "}
                <a
                  href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/rbm-policies`}
                  className=""
                  target="_blank"
                >
                  RBM Policies
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
};

export default Footer;
